import { render } from "./p-image.vue?vue&type=template&id=3754818a&scoped=true"
import script from "./p-image.vue?vue&type=script&lang=js"
export * from "./p-image.vue?vue&type=script&lang=js"

import "./p-image.vue?vue&type=style&index=0&id=3754818a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3754818a"]])

export default __exports__